import { images } from "../../../../constants";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import CallIcon from "@mui/icons-material/Call";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { useState, useEffect } from "react";
import {
  useGetShopRatingQuery,
  useGetVendorLikeDislikeQuery,
  useGetSubscriptionPurchasesByShopQuery,
} from "../../../../features/shop/shopApiSlice";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import ReportIcon from "@mui/icons-material/Report";
import SettingsIcon from "@mui/icons-material/Settings";
import CampaignIcon from "@mui/icons-material/Campaign";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import StarIcon from "@mui/icons-material/Star";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./companySidebar.css";
import Qrmodal from "../../../../components/QRmodal/Qrmodal";
import Desmodal from "../../../../components/Des_Modal";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { getAsset } from "../../../../helpers/helper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import noImagePlaceholder from "../../../../assets/images/dummy/no_image_placeholder.png";
import ShopStarRankLink from "../../../../components/ShopStarRank/ShopStarRankLink";
const BusinessPropertySideBar = ({
  navigateTo,
  Name,
  Add,
  post,
  setSuggest,
  suggestdatta,
  shopData,
  isLoading,
}) => {
  const [showmodal, setShowmodal] = useState(false);
  const [showrating, setShowrating] = useState();
  const [TLike, setTLike] = useState(null);
  const [TDislike, setTDislike] = useState(null);
  const closemodal = () => setShowmodal(false);
  const { id } = useParams();
  const { name } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const isOwner =
    name?._id &&
    shopData?.userid &&
    (name._id === shopData.userid ||
      name._id.toString() === shopData.userid.toString());
  // const [shopData, setshopData] = useState();
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Click on address to view map
    </Tooltip>
  );
  const [desshow, setDesshow] = useState(false);
  const [addrshow, setAddrshow] = useState(false);

  const handleClosedes = () => setDesshow(false);
  const handleShowdes = () => setDesshow(true);
  const handleCloseAddr = () => setAddrshow(false);
  const handleShowAddr = () => setAddrshow(true);
  const { data: ratingRes } = useGetShopRatingQuery(id, { skip: !id });

  useEffect(() => {
    if (ratingRes?.success) {
      setShowrating(ratingRes?.data?.averageRating);
    }
  }, [ratingRes]);

  const { data: likeDislikeRes } = useGetVendorLikeDislikeQuery(id, {
    skip: !id,
  });

  const { data: purchaseResponse, isLoading: isPurchaseLoading } =
    useGetSubscriptionPurchasesByShopQuery(id, { skip: !id });

  useEffect(() => {
    if (likeDislikeRes?.success && likeDislikeRes?.data?.length > 0) {
      const item = likeDislikeRes.data[0];
      setTLike(item.Tlike);
      setTDislike(item.Tdislike);
    }
  }, [likeDislikeRes]);

  return (
    <Row>
      <Desmodal
        desshow={desshow}
        handleClosedes={handleClosedes}
        des={shopData?.description}
      />
      <Desmodal
        desshow={addrshow}
        handleClosedes={handleCloseAddr}
        des={shopData?.companyaddress}
        title="Full Address"
      />
      <Qrmodal show={showmodal} handleClosemodal={closemodal} />
      <Col
        className="shop-profile-box  pt-1 px-3  ms-0 me-0 screenHeight"
        md={12}
        lg={12}
      >
        {isOwner && (
          <div
            className="d-flex justify-content-center pb-2 cursor_P"
            onClick={() => navigate(`${navigateTo}/` + id)}
          >
            <img className="w-img" src={images.UpdateShop} alt="UpdateShop" />
            <h6 className="mb-0 ps-2 pt-1 updateSize cursor">{Name}</h6>
          </div>
        )}
        <div>
          {isLoading ? (
            <Skeleton height={200} className="w-100 shop-profile-img" />
          ) : (
            (() => {
              const rawImg =
                shopData?.image ||
                shopData?.images ||
                shopData?.imageUrl ||
                shopData?.logo ||
                shopData?.profileImage ||
                shopData?.coverImage;
              let validImgStr = "";
              if (Array.isArray(rawImg)) {
                validImgStr =
                  rawImg.flat(Infinity).find((i) => i && typeof i === "string" && i.trim() !== "") ||
                  "";
              } else if (typeof rawImg === "string") {
                validImgStr = rawImg.trim();
              } else if (rawImg && typeof rawImg === "object") {
                validImgStr =
                  rawImg.url || rawImg.image || rawImg.imageUrl || rawImg.path || rawImg.src || "";
              }
              const finalSrc = validImgStr ? getAsset(validImgStr) : noImagePlaceholder;

              return (
                <img
                  className="w-100 shop-profile-img"
                  src={finalSrc}
                  alt="Shop Profile"
                  onError={(e) => {
                    if (e.target.src !== noImagePlaceholder) {
                      e.target.src = noImagePlaceholder;
                    }
                  }}
                />
              );
            })()
          )}
        </div>
        <div className="box-container mt-1">
          <Row>
            <Col lg="9">
              <div className="pt-2 pb-1">
                <h4 className="shop-Profile-font mb-0 pb-1 ">
                  {shopData?.companyname || shopData?.shopname || shopData?.profileName || shopData?.name || "Business Profile"}
                </h4>
                <Col lg="8">
                  <p className="shop-profile-para mb-0 d-flex">
                    <div>{(shopData?.description || shopData?.desc || shopData?.about || "No description")?.slice(0, 10)}</div>
                    <div>
                      {(shopData?.description || shopData?.desc || shopData?.about || "")?.length > 10 && (
                        <p
                          onClick={handleShowdes}
                          className="mb-0 cursor_P font_11 text-dark"
                          style={{ marginTop: "3px" }}
                        >
                          &nbsp;<b>ReadMore...</b>
                        </p>
                      )}
                    </div>
                  </p>
                </Col>
              </div>
            </Col>
            <Col lg="3">
              <div className="d-flex justify-content-end">
                <QrCodeScannerIcon onClick={() => setShowmodal(true)} />
              </div>
            </Col>
          </Row>
          <ShopStarRankLink
            shop={shopData}
            shopId={shopData?._id || id}
            enableCompanyFallback
            businessType="businessPropertyCompany"
          />
          <Row>
            {/* <Col lg={12} xl={12}>
              <p className="shop-profile-para mb-0 ">{shopData?.description}</p>
            </Col> */}
          </Row>

          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
          >
            <div>
              <div className="d-flex align-items-start">
                <LocationCityIcon className="silver-icon mt-1" />
                <div className="ps-2" style={{ flex: 1, minWidth: 0 }}>
                  <p
                    className="mb-0 ViewlabelText pt-1 pb-1"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      wordBreak: "break-word",
                    }}
                  >
                    {shopData?.companyaddress || shopData?.shopaddress || (typeof shopData?.address === "string" ? shopData?.address : shopData?.address?.city) || shopData?.resolvedCity || "Location not specified"}
                  </p>
                  {shopData?.companyaddress && shopData.companyaddress.length > 40 && (
                    <span
                      onClick={handleShowAddr}
                      className="cursor_P font_11 text-dark"
                      style={{ fontWeight: "bold" }}
                    >
                      See More
                    </span>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center">
                <StorefrontIcon className="silver-icon" />
                <p className="mb-0 ViewlabelText pt-1 pb-1 ps-2">
                  {shopData?.marketplace || shopData?.marketPlace || shopData?.businessType || "Marketplace"}
                </p>
              </div>
            </div>
          </OverlayTrigger>
        </div>

        <div>
          <div>
            <div className="d-flex">
              <div className="">
                <div className="d-flex align-items-center  pb-2 mt-2 cursor_P">
                  <StarIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">{showrating}</p>
                </div>
                <div className="d-flex align-items-center  pb-2 cursor_P">
                  <ThumbUpIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Liked by {TLike} </p>
                </div>
                <div className="d-flex align-items-center  pb-2 cursor_P">
                  <ThumbDownIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">
                    Unliked by {TDislike}{" "}
                  </p>
                </div>
                <div
                  className="d-flex align-items-center  pb-2 cursor_P"
                  onClick={() => {
                    setSuggest(1);
                    suggestdatta();
                  }}
                >
                  <NotificationsIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Suggestions</p>
                </div>

                <div
                  className="d-flex align-items-center cursor_P pb-2"
                  onClick={() => setSuggest(2)}
                >
                  <ReportIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Report</p>
                </div>
                <div
                  className="d-flex align-items-center pb-2 cursor_P"
                  onClick={() => navigate(`/company-setting/${id}`)}
                >
                  <SettingsIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Setting</p>
                </div>
                <div
                  className="d-flex align-items-center pb-2 cursor_P"
                  onClick={() => navigate(`/promote-shop/${id}`)}
                >
                  <CampaignIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Promote Your Shop</p>
                </div>
                <div className="d-flex align-items-center  pb-2 cursor_P">
                  <VideoCallIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Go Live</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isOwner && (
          <div className="pt-1 pb-3">
            {isPurchaseLoading && (
              <div className="d-flex justify-content-center my-1 mb-4">
                <span
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                />
              </div>
            )}
            <button
              onClick={() =>
                navigate(`/add-consultancy-services-profile/${id}`)
              }
              className="font_13 border ps-4 pe-4 pt-1 pb-1 mt-1 bg-blue text-white rounded w-100"
            >
              Add Consultancy Services
            </button>
            {!isPurchaseLoading && (
              <button
                onClick={() => {
                  const bt =
                    shopData?.businessType || "businessPropertyCompany";
                  const sid = shopData?._id || id;
                  if (bt) localStorage.setItem("BTtogetMarketer", bt);
                  if (sid) localStorage.setItem("shopid", String(sid));
                  navigate("/hire-marketers");
                }}
                className="font_13 border ps-4 pe-4 pt-1 pb-1 mt-1 bg-blue text-white rounded w-100"
              >
                Hire Us For Your Marketing & Ads
              </button>
            )}
          </div>
        )}
      </Col>
    </Row>
  );
};

export default BusinessPropertySideBar;
